import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsByIdParams,
  GetMarathonsByIdResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathonsById = createAsyncThunk<
  GetMarathonsByIdResponse,
  GetMarathonsByIdParams
>(
  "marathons/getMarathonsById",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonsById({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting marathons by id", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting marathons by id", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
